import { Autocomplete, AutocompleteProps } from '@mui/material';
import React from 'react';

import { useSxStyles } from './useStyles';

export const LegacyAutocomplete = <
  T,
  Multiple extends boolean | undefined = undefined,
  DisableClearable extends boolean | undefined = undefined,
  FreeSolo extends boolean | undefined = undefined,
>(
  props: AutocompleteProps<T, Multiple, DisableClearable, FreeSolo>,
) => {
  const { sx, ...rest } = props;
  const sxStyles = useSxStyles();

  const autocompleteProps: AutocompleteProps<
    T,
    Multiple,
    DisableClearable,
    FreeSolo
  > = {
    ...rest,
    sx: { ...(sxStyles.autoComplete || {}), ...(sx || {}) },
  };

  return <Autocomplete {...autocompleteProps} />;
};
